import { render } from "./category-form-page.vue?vue&type=template&id=1d6d4cf7"
import script from "./category-form-page.vue?vue&type=script&lang=js"
export * from "./category-form-page.vue?vue&type=script&lang=js"

import exportComponent from "/Users/girgisnabil/Documents/projects/home-food-plus-full-stack/source/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__